import { writable, get } from 'svelte/store';
import map from 'lodash/map';
import filter from 'lodash/filter';
import { t } from '../lib/i18n/t';
const isFullName = (fullName) => {
    if (typeof fullName !== 'string')
        return false;
    return /[a-z]+/i.test(fullName);
};
const isEmail = (email) => {
    if (typeof email !== 'string')
        return false;
    return /^\w([.-]?\w+)*@\w([.-]?\w+)*(.\w{2,3})+$/.test(email);
};
const isPhone = (phone) => {
    if (typeof phone !== 'string')
        return false;
    return /^((\+|00)[0-9]{3})?[0-9]{9}$/.test(phone);
};
export const reservationFieldStatuses = writable({
    fullName: { error: null },
    email: { error: null },
    phone: { error: null },
    mmb_rz_tp: { error: null },
});
export const reservationFormValidation = (data) => {
    const fields = get(reservationFieldStatuses);
    map(fields, (field) => field.error = null);
    if (data.fullName === null || data.fullName.length === 0) {
        fields.fullName.error = t('form.error.zadejteJmenoAPrijmeni');
    }
    else if (isFullName(data.fullName) === false) {
        fields.fullName.error = t('form.error.zadejteJmenoAPrijmeni');
    }
    if (data.email === null || data.email.length === 0) {
        fields.email.error = t('form.error.zadejteEmail');
    }
    else if (isEmail(data.email) === false) {
        fields.email.error = t('form.error.zadejteEmailVeSpravnemTvaru');
    }
    if (data.phone === null || data.phone.length === 0) {
        fields.phone.error = t('form.error.zadejteTelefon');
    }
    else if (isPhone(data.phone) === false) {
        fields.phone.error = t('form.error.zadejteTelefonVeSpravnemTvaru');
    }
    if (data.isMmbRzSp && data.mmb_rz_tp === null || String(data.mmb_rz_tp).length === 0) {
        fields.mmb_rz_tp.error = t('form.error.zadejteOznaceniVozidla');
    }
    reservationFieldStatuses.set(fields);
    return filter(fields, (field) => field.error !== null).length ? false : true;
};
